import { render, staticRenderFns } from "./DownloadSellerPDF.vue?vue&type=template&id=1122049e"
import script from "./DownloadSellerPDF.vue?vue&type=script&lang=js"
export * from "./DownloadSellerPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports